module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "konfigurator-order"
    }
  }, [_c('right-content-header'), _vm._v(" "), _c('h2', [_vm._v("Objednávka")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "views-field views-field-field-model-cena-davky"
  }, [(_vm.$store.state.mazlicek.krmivo.tydny.value !== 0) ? _c('div', {
    staticClass: "vaha-krmiva-celkem"
  }, [_c('div', {
    staticClass: "cena-label"
  }, [_vm._v("\n\t\tVáha krmiva\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "cena-value"
  }, [_c('span', [_vm._v(_vm._s(_vm.round(_vm.totalWeight / 100) / 10) + " kg / " + _vm._s(_vm.round((_vm.totalWeight * 0.00220462262) * 10 | _vm.round) / 10) + " lb")])])]) : _c('div', {
    staticClass: "vaha-krmiva-celkem"
  }, [_c('div', {
    staticClass: "cena-label"
  }, [_vm._v("\n\t\t    Váha krmiva\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "cena-value"
  }, [_c('span', [_vm._v(_vm._s(_vm.naZkouskuVaha) + " g")])])]), _vm._v(" "), (_vm.showTotalPrice) ? _c('div', {
    staticClass: "cena-davky"
  }, [_c('div', {
    staticClass: "cena-label"
  }, [_vm._v("\n                    Cena / den\n                ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.priceIsBeingCalculated),
      expression: "!priceIsBeingCalculated"
    }],
    staticClass: "cena-value"
  }, [_c('span', [_vm._v(_vm._s((_vm.pricePerDay + '').replace('.', ',')) + " Kč")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.priceIsBeingCalculated),
      expression: "priceIsBeingCalculated"
    }],
    staticClass: "cena-value"
  }, [_c('span', [_vm._v("přepočítávám")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cena-complete"
  }, [_c('div', {
    staticClass: "cena-label"
  }, [_vm._v("\n              Cena\n            ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.priceIsBeingCalculated),
      expression: "!priceIsBeingCalculated"
    }],
    staticClass: "cena-value"
  }, [_c('span', [_vm._v(_vm._s(_vm.totalPrice) + " Kč")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.priceIsBeingCalculated),
      expression: "priceIsBeingCalculated"
    }],
    staticClass: "cena-value"
  }, [_c('span', [_vm._v("přepočítávám")])])]), _vm._v(" "), (_vm.isFirstOrder) ? _c('div', {
    staticClass: "cena-complete first-order"
  }, [_c('div', {
    staticClass: "cena-label"
  }, [_vm._v("\n              Super cena na první měsíc\n            ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.priceIsBeingCalculated),
      expression: "!priceIsBeingCalculated"
    }],
    staticClass: "cena-value"
  }, [_c('span', [_vm._v(_vm._s(_vm.roundPrice(_vm.mazlicek.orderData.firstOrderPrice)) + " Kč")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.priceIsBeingCalculated),
      expression: "priceIsBeingCalculated"
    }],
    staticClass: "cena-value"
  }, [_c('span', [_vm._v("přepočítávám")])])]) : _vm._e()]), _vm._v(" "), (_vm.isFirstOrder) ? _c('div', {
    staticClass: "objednavka-btn-text first-order"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.firstOrderText)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.additional_info_order) ? _c('div', {
    staticClass: "objednavka-btn-text"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.additional_info_order.content)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.mazlicek.orderData.activeSubscription) ? _c('div', {
    staticClass: "objednavka-btn-text"
  }, [_vm._v("\n            " + _vm._s(_vm.mazlicek.orderData.isFirstOrderSent ? 'První' : 'Další') + " krmivo odesíláme: " + _vm._s(_vm.mazlicek.orderData.orderSendDate) + "\n        ")]) : _c('div', {
    staticClass: "objednavka-btn"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.objednatKrmivo
    }
  }, [_vm._v("OBJEDNAT")])]), _vm._v(" "), _c('info-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showInfoModal),
      expression: "showInfoModal"
    }],
    attrs: {
      "button-text": 'OK',
      "message": _vm.infoModalMessage
    },
    on: {
      "close": function($event) {
        _vm.showInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "objednavka-btn-text"
  }, [_c('span', [_vm._v("Krmivo na 4 týdny")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-319dc110","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order.vue
// module id = 567
// module chunks = 1